import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAuth } from './authSlice';

const ForceLogin = () => {
    const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      navigate("/", { replace: true });
      return;
    }

    try {
      const decoded = JSON.parse(atob(token));

      localStorage.setItem("authData", JSON.stringify(decoded));

      // Keep Redux auth state in sync so selectors like selectIsLoggedIn
      // reflect the new session immediately (and /me runs without refresh).
      dispatch(setAuth(decoded));

      navigate("/", { replace: true });
    } catch (e) {
      console.error("Invalid token", e);
      navigate("/", { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      Loading...
    </div>
  );
};

export default ForceLogin